import React, { useEffect } from "react";
import { useParams } from "react-router";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { StatCards } from "components/statCards";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { usePrestacaoContasState } from "./context/prestacao-contas-context";
import { usePrestacaoContasController } from "./context/prestacao-contas-controller";
import { PrestacaoContasTable } from "./prestacaoContasTable.component";

export function PrestacaoContasPage() {
  const { prestacoesContas, prestacaoContasPagedRequest, loading, tipos, ultimaAtualizacao, totais, error } = usePrestacaoContasState();
  const { onInit, handleOnChange, listPrestacoesContas, exportPrestacoesContas } = usePrestacaoContasController();
  const { tipoId } = useParams<{ tipoId?: string }>();
  const tipoSelecionado = tipos?.find(t => t.id === Number(tipoId));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit(tipoId ? Number(tipoId) : undefined);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoId]);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listPrestacoesContas({ ...prestacaoContasPagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Planejamento e Prestação de Contas", href: "/prestacao-contas" },
          ...(tipoSelecionado ? [{ label: tipoSelecionado.name }] : []),
        ]}
      />
      <PageTitle>{tipoSelecionado ? tipoSelecionado.name : "Planejamento e Prestação de Contas"}</PageTitle>
      <Wrapper>
        <StatCards
          items={[
            { label: "Total de Registros", value: String(totais?.total ?? 0), variant: 'blue' },
            { label: "Em Execução", value: String(totais?.emExecucao ?? 0) },
            { label: "Finalizados", value: String(totais?.finalizados ?? 0), variant: 'green' },
          ]}
        />
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Descrição"
                  value={prestacaoContasPagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-ano"
                  label="Ano"
                  value={prestacaoContasPagedRequest?.ano || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Tipo de Documento</InputLabel>
                  <Select
                    name="select-tipo-id"
                    value={prestacaoContasPagedRequest?.idTipoDocumentoPrestacaoContas || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Tipo de Documento"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {tipos?.filter((t) => !t.name.toUpperCase().includes("AUDITORIA")).map((t) => (
                      <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SearchButton onClick={() => (async () => {
                  await listPrestacoesContas(prestacaoContasPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={prestacaoContasPagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportPrestacoesContas} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <PrestacaoContasTable currentItems={prestacoesContas} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={prestacoesContas?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
